import { useMemo, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, type SelectProps } from 'antd';
import type { SimDataMeta } from '../../../types/domain';
import { useCurrentSimDataId } from '../../../hooks/SimViewer/useCurrentSimDataId';
import { useMetaData } from '../../../hooks/data/useMetaData';
import { useSchemaComparison } from '../../../hooks/SimViewer/useSchemaComparison';

type Option = NonNullable<SelectProps['options']>[number] & {
  label: string;
  value: string;
};

const SchemaSelector = (): ReactNode => {
  const { t } = useTranslation();
  const { currentSimDataId } = useCurrentSimDataId();
  const { allDataMetas } = useMetaData();
  const { comparisons, setComparisons } = useSchemaComparison();

  const options = useMemo((): Option[] => {
    return Array.from(allDataMetas.values())
      .filter((simDataMeta: SimDataMeta): boolean => {
        return simDataMeta.simdata_id !== currentSimDataId;
      })
      .map((simDataMeta: SimDataMeta): Option => {
        return {
          label: simDataMeta.name,
          value: simDataMeta.simdata_id,
        };
      });
  }, [allDataMetas, currentSimDataId]);

  const filterOption = (
    input: string,
    option?: Option | undefined
  ): boolean => {
    return (
      !!option &&
      (option.label.toLowerCase().includes(input.toLowerCase()) ||
        option.value.toLowerCase().includes(input.toLowerCase()))
    );
  };

  return (
    <Select
      mode="multiple"
      allowClear
      style={{ width: '100%' }}
      placeholder={t('message.selectToCompare')}
      onChange={(value: string[]): void => {
        setComparisons(value);
      }}
      value={comparisons}
      options={options}
      filterOption={filterOption}
    />
  );
};

export { SchemaSelector };
